import { motion } from "framer-motion";
import { RETAILERS } from "../config";

export const Retailers = () => {
  return (
    <section id="retailers" data-testid="retailers-section" className="relative bg-[#12100a] border-t border-[#d8ab4e]/15 py-24 md:py-32">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="mb-12 md:mb-16 max-w-3xl">
          <p className="font-grotesk uppercase tracking-[0.35em] text-xs text-[#d8ab4e] mb-6">Available Everywhere</p>
          <h2 className="font-display text-4xl sm:text-6xl leading-[0.95]">
            Find it at your <span className="gold-text italic">favourite</span> store.
          </h2>
          <p className="mt-6 font-body text-[#9a8f78] text-lg">
            Rolling out across major retailers and print-on-demand platforms. More links go live as distribution expands.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {RETAILERS.map((r, i) => {
            const live = Boolean(r.href);
            return (
              <motion.a
                key={r.name}
                href={live ? r.href : "#retailers"}
                target={live ? "_blank" : undefined}
                rel={live ? "noopener noreferrer" : undefined}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.06, ease: [0.22, 1, 0.36, 1] }}
                data-testid={`retailer-${r.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className={`group flex items-center justify-between border px-6 py-6 transition-colors ${
                  live
                    ? "border-[#d8ab4e]/40 hover:border-[#f2c968] hover:bg-[#d8ab4e]/10 cursor-pointer"
                    : "border-[#d8ab4e]/15 cursor-default"
                }`}
              >
                <span className={`font-display text-xl md:text-2xl ${live ? "text-[#f3ead6]" : "text-[#7d7460]"}`}>
                  {r.name}
                </span>
                {live ? (
                  <span className="text-[#d8ab4e] transition-transform group-hover:translate-x-1">→</span>
                ) : (
                  <span className="text-[10px] uppercase tracking-[0.2em] text-[#6b6350]">Soon</span>
                )}
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Retailers;
